import {
  IconButton,
  useColorMode,
  useColorModeValue,
  keyframes,
} from "@chakra-ui/react";
import { DarkMode, LightMode } from "../theme/icons";

function ToggleColor() {
  const { toggleColorMode } = useColorMode();
  const label = useColorModeValue("dark", "light");
  const icon = useColorModeValue(<DarkMode />, <LightMode />);
  const rotateIn = keyframes`  
    from {transform: translateX(${useColorModeValue(
    "8px",
    "-8px"
  )}); rotate: ${useColorModeValue("15deg", "-15deg")}}   
    to {transform: translateX(0); rotate: 0} 
  `;
  const colorToggleAnimation = `${rotateIn} 0.32s ease-out`;
  const bgColor = useColorModeValue(
    "rgba(246, 246, 247, 1)",
    "rgba(18, 28, 37, 1)"
  );

  return (
    <IconButton
      variant="base-fill"
      overflow="hidden"
      sx={{ "> svg": { animation: colorToggleAnimation } }}
      colorScheme="gray"
      onClick={toggleColorMode}
      size="xs"
      title={`Switch to ${label} color`}
      icon={icon}
      bg={bgColor}
      aria-label="Toggle color mode"
    />
  );
}

export default ToggleColor;
